import Chart from 'chart.js'

/**
 * @module
 * @name chartBarAverage
 */
export default {
  name: 'chartBarAverage',
  props: {
    chartType: {
      type: String
    },
    barThicknessChart: {
      type: Number
    },
    barLenghtChart: {
      type: Number
    },
    stepSizeBarX: {
      type: String
    },
    stepSizeBarY: {
      type: String
    },
    dataBarChart: {
      type: Array
    },
    isAxeHidden: {
      type: Boolean
    },
    titleBarChart: {
      type: String
    },
    isTitledisplayed: {
      type: Boolean
    },
    areGridsHidden: {
      type: Boolean
    },
    avgDataBars: {
      type: Array
    }
  },
  data () {
    return {
      barChart: null
    }
  },
  watch: {
    dataBarChart (dataChart) {
      this.barChart.data.labels = this.handleGetDataChart(dataChart, 'label')
      this.barChart.data.datasets.forEach((dataset) => {
        dataset.data = this.handleGetDataChart(dataChart, 'amount')
      })
      this.barChart.update()
    }
  },
  methods: {
    handleGetDataChart (arrData, elem) {
      let arrDataItems = arrData.map(item => {
        return item[elem]
      })
      return arrDataItems
    },
    getTotalIncreaseAmount (arr) {
      const amounts = arr.map(elem => elem.amount)
      const greatestAmount = Math.trunc(Math.max(...amounts))
      const totalIncreaseAmount = greatestAmount + ((greatestAmount * 20) / 100)
      return totalIncreaseAmount
    },
    handleCreateBarChart (dataChart) {
      this.barChart = new Chart(this.$refs.canvas, {
        type: this.chartType,
        data: {
          labels: this.handleGetDataChart(dataChart, 'label'),
          datasets: [{
            label: 'Total',
            backgroundColor: '#007DE3',
            borderColor: '#007DE3',
            data: this.handleGetDataChart(dataChart, 'amount'),
            barThickness: this.barThicknessChart,
            minBarLength: this.barLenghtChart,
            order: 1
          },
          {
            label: 'Average',
            data: this.avgDataBars,
            order: 2,
            backgroundColor: '#E4EEF6',
            borderColor: '#E4EEF6'
          }
          ]
        },
        options: {
          title: {
            display: !!this.isTitledisplayed,
            text: this.titleBarChart
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              gridLines: {
                display: !this.areGridsHidden
              },
              ticks: {
                display: !this.isAxeHidden,
                autoSkip: false,
                maxRotation: 0,
                stepSize: 5
              }
            }],
            yAxes: [{
              ticks: {
                beginAtZero: true,
                stepSize: 200,
                suggestedMax: this.getTotalIncreaseAmount(dataChart)
              }
            }]
          }
        }
      })
    }
  },
  mounted () {
    this.handleCreateBarChart(this.dataBarChart)
  }
}
